import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({
  children,
  page,
  allowedPages = [],
  accessReady = true,
  fallbackPath = "/source-data",
}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (user.role !== "admin") {
    return <Navigate to={fallbackPath} replace />;
  }
  if (!accessReady) {
    return null;
  }
  if (page && !allowedPages.includes(page)) {
    return <Navigate to={fallbackPath} replace />;
  }
  return children;
};

export default AdminRoute;
